/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { CommonKeyCombinations } from "../../common/KeyCombinations";
import { IEditor } from "../../IEditor";
import { CMD } from "../../commands/CMD";

export function registerKeyBindings(dc: IEditor): void {
	const viewSvc = dc.get("viewService");
	const keyBindingSvc = dc.get("keyBindingService");

	keyBindingSvc.register({
		id: "readmeEditor.edit.save",
		label: "Save Readme",
		commandId: CMD.README_EDITOR.EDIT.SAVE,
		keys: CommonKeyCombinations.save,
		when: () => viewSvc.isViewActive("readmeEditor.edit")
	});

	keyBindingSvc.register({
		id: "readmeEditor.edit.undo",
		label: "Undo",
		commandId: CMD.README_EDITOR.EDIT.UNDO,
		keys: CommonKeyCombinations.undo,
		when: () => viewSvc.isViewActive("readmeEditor.edit")
	});

	keyBindingSvc.register({
		id: "readmeEditor.edit.redo",
		label: "Redo",
		commandId: CMD.README_EDITOR.EDIT.REDO,
		keys: CommonKeyCombinations.redo,
		when: () => viewSvc.isViewActive("readmeEditor.edit")
	});
}
